export default __webpack_public_path__ + "static/media/green-tick.bdbe1186.svg";